import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function Depolar() {
  const navigate = useNavigate();
  const [depolar, setDepolar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ ad: '', sehir: '' });
  const [duzenle, setDuzenle] = useState(null);

  useEffect(() => { fetchDepolar(); }, []);

  async function fetchDepolar() {
    const { data } = await supabase.from('depolar').select('*').order('ad');
    setDepolar(data || []);
    setLoading(false);
  }

  async function handleKaydet() {
    if (!form.ad) return;
    if (duzenle) {
      await supabase.from('depolar').update({ ad: form.ad, sehir: form.sehir }).eq('id', duzenle);
    } else {
      await supabase.from('depolar').insert({ ad: form.ad, sehir: form.sehir });
    }
    setModal(false);
    fetchDepolar();
  }

  async function handleSil(id) {
    if (!window.confirm('Bu depoyu silmek istediğinizden emin misiniz?')) return;
    await supabase.from('depolar').delete().eq('id', id);
    fetchDepolar();
  }

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Depolar</h1>
          <p className="page-subtitle">{depolar.length} depo kayıtlı</p>
        </div>
        <button className="btn btn-primary" onClick={() => { setForm({ ad: '', sehir: '' }); setDuzenle(null); setModal(true); }}>+ Yeni Depo</button>
      </div>

      <div className="card" style={{ padding: 0 }}>
        <table className="table">
          <thead>
            <tr><th>Depo Adı</th><th>Şehir</th><th>Durum</th><th>İşlem</th></tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={4} className="loading">Yükleniyor...</td></tr>
            ) : depolar.length === 0 ? (
              <tr><td colSpan={4} style={{ textAlign: 'center', padding: 40, color: 'var(--text2)' }}>Henüz depo eklenmemiş.</td></tr>
            ) : depolar.map(d => (
              <tr key={d.id}>
                <td style={{ fontWeight: 600 }}>{d.ad}</td>
                <td style={{ color: 'var(--text2)' }}>{d.sehir || '-'}</td>
                <td><span className={`badge ${d.aktif ? 'badge-green' : 'badge-red'}`}>{d.aktif ? '✓ Aktif' : '✗ Pasif'}</span></td>
                <td>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button className="btn btn-ghost btn-sm" onClick={() => navigate(`/depolar/${d.id}`)}>Stok Görüntüle</button>
                    <button className="btn btn-ghost btn-sm" onClick={() => { setForm({ ad: d.ad, sehir: d.sehir || '' }); setDuzenle(d.id); setModal(true); }}>Düzenle</button>
                    <button className="btn btn-danger btn-sm" onClick={() => handleSil(d.id)}>Sil</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">{duzenle ? 'Depo Düzenle' : 'Yeni Depo'}</h3>
            <div className="form-group">
              <label className="label">Depo Adı *</label>
              <input className="input" value={form.ad} onChange={e => setForm(f => ({ ...f, ad: e.target.value }))} placeholder="İstanbul Avrupa Depo..." autoFocus />
            </div>
            <div className="form-group">
              <label className="label">Şehir</label>
              <input className="input" value={form.sehir} onChange={e => setForm(f => ({ ...f, sehir: e.target.value }))} placeholder="İstanbul, Ankara..." />
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn btn-ghost" onClick={() => setModal(false)}>İptal</button>
              <button className="btn btn-primary" onClick={handleKaydet} disabled={!form.ad}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
